import {Injectable,} from '@angular/core';
import {BehaviorSubject, Observable,} from 'rxjs';

/**
 * ローディング画面の状態を制御するためのサービス.
 */
@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _subject = new BehaviorSubject<boolean>(false);
  private _count = 0;

  /**
   * ローディング中かどうか.
   */
  public get loading$(): Observable<boolean> {
    return this._subject.asObservable();
  }

  /**
   * ローディングをスタートする(カウントで管理しているため、複数の非同期処理の同期呼び出しに対応している).
   */
  start(): void {
    //画面事に設定しているローディング表示をインターセプタで一律表示させる方針とするため、既存ローディング
    //呼び出し部分とのデグレード防止のため実装を削除
  }

  /**
   * ローディングをストップする.
   * @param [force=false] カウントによらず強制ストップする場合、true
   */
  stop(): void {
    //画面事に設定しているローディング表示をインターセプタで一律表示させる方針とするため、既存ローディング
    //呼び出し部分とのデグレード防止のため実装を削除
  }

  /**
   * ローディングをスタートする(カウントで管理しているため、複数の非同期処理の同期呼び出しに対応している).
   */
  startAllApi(): void {
    ++this._count;
    this._subject.next(true);
  }

  /**
   * ローディングをストップする.
   * @param [force=false] カウントによらず強制ストップする場合、true
   */
  stopAllApi(force = false): void {
    --this._count;
    if (force || this._count <= 0) {
      this._count = 0;
      this._subject.next(false);
    }
  }
}
